"use client";
// import Hero from "@/components/hero";
import AboutUs from "@/components/sections/about-us";
import OurProgram from "@/components/sections/our-program";
import UpcomingEvents from "@/components/sections/upcoming-events";
import WhatSetsUsApart from "@/components/sections/what-sets-us-apart";
import OurSuccessStories from "@/components/sections/our-success-stories";
import Collaboration from "@/components/sections/collaboration";
import { cn } from "@/lib/utils";
import PcpsResearch from "@/components/sections/pcps-research";

/* const Hero = dynamic(() => {
    return import("../components/hero")
}, { ssr: false }) */
import Hero from "@/components/hero";

export default function HomeClient() {

    return (
        <main>
            <article className={cn(
                `float-left w-full clear-both`
            )}>
                <Hero />

                <div className={cn(
                    `clear-both z-[3]`,
                    `2xl:p-[1px_5rem] xl:p-[0_5rem] md:p-[0_3.125rem] p-[1rem_1.25rem]`
                )}>
                    <AboutUs />
                    <OurProgram />

                    <WhatSetsUsApart />

                    {/* <TechInsight /> */}
                    <UpcomingEvents />

                    {/* <WeeklyTechInsight /> */}
                    <PcpsResearch />

                    <OurSuccessStories />
                    <Collaboration />

                </div>
            </article>
        </main>
    );
}